// import React from 'react';

// const CustomerCard = ({ customer, onSelect, compact = false }) => {
//   return (
//     <div 
//       className={`customer-card ${compact ? 'customer-card-compact' : ''}`} 
//       onClick={() => onSelect(customer.id)}
//     >
//       <div className="customer-info">
//         <h3 className="customer-name">{customer.name}</h3>
//         <div className="customer-phone">{customer.id}</div>
//         {!compact && <div className="customer-location">{customer.city}</div>}
//       </div>
//       <div className="customer-points">
//         <div className="points-value">{customer.totalPoints}</div>
//         <div className="points-label">points</div>
//         {customer.totalPoints >= 1000 && (
//           <div className="redemption-badge">Eligible</div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CustomerCard;

import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomerCard = ({ customer, onSelect, compact = false, isRTL = false, minRedemptionPoints = 1000 }) => {
  const { t } = useTranslation();
  
  return (
    <div 
      className={`customer-card ${compact ? 'customer-card-compact' : ''} ${isRTL ? 'rtl' : ''}`} 
      onClick={() => onSelect(customer.id)}
    >
      <div className="customer-info">
        <h3 className="customer-name">{customer.name}</h3>
        <div className="customer-phone">{customer.id}</div>
        {!compact && <div className="customer-location">{customer.city}</div>}
      </div>
      <div className="customer-points">
        <div className="points-value">{customer.totalPoints}</div>
        <div className="points-label">{t('customers.points')}</div>
        {customer.totalPoints >= minRedemptionPoints && (
          <div className="redemption-badge">{t('customers.eligible')}</div>
        )}
      </div>
    </div>
  );
};

export default CustomerCard;